import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿En qué formato recibo el material?',
  answer: '100% digital (PDF descargables) listos para usar desde cualquier dispositivo. Acceso inmediato a todo el contenido.'
}, {
  question: '¿Puedo imprimir las clases y actividades?',
  answer: '¡Sí! Todo el material está diseñado para ser impreso fácilmente.'
}, {
  question: '¿Para qué años de secundaria sirve?',
  answer: 'Para todos los años donde se dicte Política y Ciudadanía. Contenidos adaptables según el nivel y los diseños curriculares vigentes.'
}, {
  question: '¿Las actividades son difíciles de implementar?',
  answer: 'Para nada. Vienen con instrucciones claras, paso a paso. Solo abrís el archivo y empezás.'
}, {
  question: '¿Cuánto tarda en llegar el acceso?',
  answer: 'El acceso es inmediato. Completás la compra y recibís el enlace de descarga por email en minutos.'
}, {
  question: '¿Hay actualizaciones incluidas?',
  answer: 'Sí, todas las actualizaciones futuras están incluidas sin costo adicional.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-white py-12 px-4 sm:px-6 lg:px-8" data-id="element-42">
      <div className="max-w-2xl mx-auto" data-id="element-43">
        <h2 className="text-xl sm:text-2xl font-bold text-[#1e3a5a] text-center mb-6" data-id="element-44">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-2" data-id="element-45">
          {faqs.map((faq, index) => <div key={index} className="border border-[#d4a853]/20 rounded-xl overflow-hidden" data-id="element-46">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-5 py-4 text-left flex items-center justify-between gap-3 hover:bg-[#FDF6E3] transition-colors" data-id="element-47">
                <span className="font-semibold text-[#1e3a5a] text-sm sm:text-base" data-id="element-48">
                  {faq.question}
                </span>
                <ChevronDown className={`w-4 h-4 text-[#d4a853] flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-49" />
              </button>
              <div className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-40' : 'max-h-0'}`} data-id="element-50">
                <div className="px-5 pb-4 text-sm text-gray-600 leading-relaxed" data-id="element-51">
                  {faq.answer}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}